import React from 'react';
import './style.css';
import 'katex/dist/katex.min.css';
import { InlineMath, BlockMath } from 'react-katex';

// Very small parser to support:
// - Block math: $$ ... $$
// - Inline math: $ ... $
// Everything else stays as plain text.
const splitBlockMath = (text) => {
    const segments = [];
    const regex = /\$\$([\s\S]+?)\$\$/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            segments.push({ type: 'text', content: text.slice(lastIndex, match.index) });
        }
        segments.push({ type: 'math', display: true, content: match[1] });
        lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
        segments.push({ type: 'text', content: text.slice(lastIndex) });
    }

    return segments;
};

const splitInlineMath = (text) => {
    const segments = [];
    const regex = /\$([^$\n]+)\$/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            segments.push({ type: 'text', content: text.slice(lastIndex, match.index) });
        }
        segments.push({ type: 'math', display: false, content: match[1] });
        lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
        segments.push({ type: 'text', content: text.slice(lastIndex) });
    }

    return segments;
};

const renderTextWithLineBreaks = (text) => {
    const lines = text.split('\n');
    return lines.map((line, index) => (
        <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
        </React.Fragment>
    ));
};

const Text = ({ message }) => {
    const blockSegments = splitBlockMath(message || '');

    return (
        <div id="response-message" className="cugpt-response-message">
            {blockSegments.map((segment, index) => {
                if (segment.type === 'math' && segment.display) {
                    return (
                        <div key={`block-${index}`}>
                            <BlockMath math={segment.content} />
                        </div>
                    );
                }

                // Handle inline math inside normal text segments
                const inlineSegments = splitInlineMath(segment.content);
                return (
                    <span key={`text-${index}`}>
                        {inlineSegments.map((s, i) => {
                            if (s.type === 'math') {
                                return <InlineMath key={i} math={s.content} />;
                            }
                            return <React.Fragment key={i}>{renderTextWithLineBreaks(s.content)}</React.Fragment>;
                        })}
                    </span>
                );
            })}
        </div>
    );
};

export default Text;